import React, { useState } from 'react';
import logo from '../../src/img/wetrnd.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Smooth scroll function
  const handleScrollTo = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 100; // Account for fixed navbar height
      const elementPosition = element.offsetTop - navbarHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    // Close mobile menu after clicking
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-4 left-1/2 transform -translate-x-1/2 w-auto bg-white shadow-lg z-50 px-12 py-4 rounded-2xl min-w-fit">
      <div className="flex justify-center items-center">
        <div className="flex items-center space-x-16">
          {/* Logo Section */}
          <div className="flex items-center">
            <img
              src={logo}
              alt="WETREND Logo"
              style={{ height: 120, width: 'auto', minHeight: 120, minWidth: 120 }}
              className="mr-4 rounded-xl object-contain"
            />

            {/* Optionally add text */}
            {/* <h1 className="text-xl font-bold text-gray-800">WETREND</h1> */}
          </div>


          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => handleScrollTo('services')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => handleScrollTo('clients')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              Clients
            </button>
            <button
              onClick={() => handleScrollTo('whyus')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              Why WETREND?
            </button>
            <button
              onClick={() => handleScrollTo('reviews')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              Reviews
            </button>
            <button
              onClick={() => handleScrollTo('faqs')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 cursor-pointer"
            >
              FAQs
            </button>

            {/* Chat Now Button */}
            <a
              href="https://wa.me/919876543210" // use your WhatsApp number (with country code, no + or spaces)
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-gray-800 hover:bg-gray-900 text-white px-8 py-2 rounded-lg font-medium transition-colors duration-200 ml-6 whitespace-nowrap">
                Chat Now
              </button>
            </a>

          </div>
        </div>

        {/* Mobile Menu Button - positioned absolute */}
        <div className="md:hidden absolute right-4">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-gray-700 hover:text-gray-900 focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu - positioned below navbar */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl shadow-lg border border-gray-100">
          <div className="flex flex-col space-y-4 p-6">
            <button
              onClick={() => handleScrollTo('services')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 text-left"
            >
              Services
            </button>
            <button
              onClick={() => handleScrollTo('clients')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 text-left"
            >
              Clients
            </button>
            <button
              onClick={() => handleScrollTo('whyus')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 text-left"
            >
              Why WETREND?
            </button>
            <button
              onClick={() => handleScrollTo('reviews')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 text-left"
            >
              Reviews
            </button>
            <button
              onClick={() => handleScrollTo('faqs')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200 text-left"
            >
              FAQs
            </button>
            <button
              className="bg-gray-800 hover:bg-gray-900 text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200 w-fit"
              onClick={() => setIsMenuOpen(false)}
            >
              Chat Now
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;